import WorkLogManager from './WorkLogManager';

export default WorkLogManager;
